// window.axios = require('axios')
//
// window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.Laravel.csrfToken
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

window.Rellax = require('rellax/rellax.min.js')

window.waypoint = require('waypoints/lib/noframework.waypoints.min')
window.NoFrameworkAdapter = require('waypoints/src/adapters/noframework')
require('waypoints/lib/shortcuts/inview.min')

// window.VisSense = require('vissense')

window.Swiper = require('swiper/dist/js/swiper.min')

// window.Inputmask = require('inputmask')

// window.tingle = require('tingle.js')

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });
